<div class="login-wrapper p-component login-v-final">
    <!-- Dynamic Background -->
    <div class="login-bg-overlay" [ngClass]="{'login-client-bg': isClientMode}"></div>

    <div class="login-card-container fadein">
        <header class="text-center mb-5">
            <img class="logo-main" *ngIf="!appSettings?.frontend?.general?.showClientLogo" src="../../../assets/img/static/biworklims.svg" alt="Biwork LIMS">
            <img class="logo-main" *ngIf="appSettings?.frontend?.general?.showClientLogo" id='client-logo' src="../../../assets/img/client/clientLogo.png" alt="Logo">
            
            <div class="greeting-area mt-4">
                <ng-container *ngIf="isClientMode && !forgot">
                    <h1 class="text-color text-3xl font-light mb-1 mt-0">{{ cs.isBio ? 'Portal de Pacientes' : 'Portal de Clientes' }}</h1>
                    <p class="text-color-secondary text-base font-light mb-4">Acceso seguro a resultados y solicitudes</p>
                </ng-container>

                <h1 class="text-600 font-light text-5xl m-0" *ngIf="!isClientMode || forgot">{{ forgot ? 'Recuperar' : 'Hola,' }}</h1>
                <h2 class="text-primary font-bold text-4xl m-0 uppercase tracking-widest" *ngIf="!forgot">{{ text }}</h2>
                <h2 class="text-primary font-bold text-4xl m-0 uppercase tracking-widest" *ngIf="forgot">Contraseña</h2>
            </div>
        </header>

        <!-- Login Form -->
        <form *ngIf="!forgot" [formGroup]="form" (submit)='userLogin(form.value)' class="flex flex-column gap-4">
            <div *ngIf="loginErrorMessage" class="p-3 surface-100 border-round flex align-items-start gap-2 border-left-3 border-red-500">
                <i class="pi pi-times-circle text-red-600 mt-1"></i>
                <p class="m-0 text-color text-sm">{{ loginErrorMessage }}</p>
            </div>
            
            <div class="field">
                <p-floatLabel>
                    <input pInputText id="user" formControlName="user" autocomplete="off" class="w-full p-inputtext-lg" [disabled]="isLoading" />
                    <label for="user">Email / Usuario</label>
                </p-floatLabel>
                @if (form.controls.user.invalid && form.controls.user.touched) {
                    <small class="p-error block mt-1">Ingrese un email o usuario válido</small>
                }
            </div>
            
            <div class="field">
                <p-floatLabel>
                    <p-password id="password" formControlName="password" [toggleMask]="true" [feedback]="false" styleClass="w-full" inputStyleClass="w-full p-inputtext-lg" [disabled]="isLoading" autocomplete="current-password"></p-password>
                    <label for="password">Contraseña</label>
                </p-floatLabel>
                @if (form.controls.password.invalid && form.controls.password.touched) {
                    <small class="p-error block mt-1">Contraseña inválida</small>
                }
            </div>
            
            <div class="flex justify-content-end w-full">
                <span class="reset-link text-sm font-medium text-color-secondary hover:text-primary cursor-pointer transition-colors" (click)="toForgot()">¿Olvidaste tu contraseña?</span>
            </div>

            <div class="flex flex-column gap-3 mt-2 w-full">
                <!-- Honeypot -->
                <input type="text" formControlName="website" class="honeypot" tabindex="-1" autocomplete="off" style="opacity: 0; position: absolute; top: -9999px; left: -9999px;">
                <p-button label="Ingresar" type="submit" styleClass="w-full p-button-lg" [disabled]="form.invalid || isLoading" [loading]="isLoading"></p-button>
                <p-button label="Crear una cuenta" severity="secondary" [outlined]="true" *ngIf="isClientMode && cs.registerClient" (onClick)="toRegister()" [disabled]="isLoading" styleClass="w-full"></p-button>
            </div>
        </form>

        <!-- Recovery form -->
        <form *ngIf="forgot" [formGroup]="formRecovery" class="flex flex-column gap-4">
            <p *ngIf="!adminForcedChange" class="text-color-secondary text-base mb-2">Ingresa tu usuario o email, pide tu código, y completa los datos para restablecer tu contraseña.</p>
            <div *ngIf="adminForcedChange" class="p-3 mb-2 surface-100 border-round flex align-items-start gap-2 border-left-3 border-yellow-500">
                <i class="pi pi-exclamation-triangle text-yellow-600 mt-1"></i>
                <p class="m-0 text-color text-sm">Un administrador requirió la regeneración de tu clave de acceso. Por favor, solicita un código de recuperación para proceder con el cambio.</p>
            </div>
            
            <div *ngIf="errorMessage" class="p-3 mb-2 surface-100 border-round flex align-items-start gap-2 border-left-3 border-red-500">
                <i class="pi pi-times-circle text-red-600 mt-1"></i>
                <p class="m-0 text-color text-sm">{{ errorMessage }}</p>
            </div>
            
            <div class="field">
                <p-floatLabel>
                    <input pInputText id="userName" formControlName="userName" autocomplete="off" class="w-full p-inputtext-lg" [disabled]="isLoading" [readonly]="codeRequested" />
                    <label for="userName">{{ (isClientMode && cs.isBio) ? 'Email / Usuario / DNI' : 'Email / Usuario' }}</label>
                </p-floatLabel>
                @if (formRecovery.controls.userName.invalid && formRecovery.controls.userName.touched) {
                    <small class="p-error block mt-1">Ingrese su usuario o email</small>
                }
            </div>

            <div class="field flex flex-column align-items-center justify-content-center">
                <label for="code" class="text-color-secondary text-sm mb-2">Código de seguridad (6 dígitos)</label>
                <p-inputotp formControlName="code" [length]="6"></p-inputotp>
            </div>
            
            <div class="field">
                <p-floatLabel>
                    <p-password id="new_password" formControlName="password" [toggleMask]="true" [feedback]="false" styleClass="w-full" inputStyleClass="w-full p-inputtext-lg" [disabled]="isLoading"></p-password>
                    <label for="new_password">Nueva contraseña</label>
                </p-floatLabel>
                @if (formRecovery.controls.password.hasError('required') && formRecovery.controls.password.touched) {
                    <small class="p-error block mt-1">La contraseña es requerida</small>
                }
                @if (formRecovery.controls.password.hasError('minlength') && formRecovery.controls.password.touched) {
                    <small class="p-error block mt-1">Debe tener al menos 6 caracteres</small>
                }
            </div>
            
            <div class="field">
                <p-floatLabel>
                    <p-password id="passwordVal" formControlName="passwordVal" [toggleMask]="true" [feedback]="false" styleClass="w-full" inputStyleClass="w-full p-inputtext-lg" [disabled]="isLoading"></p-password>
                    <label for="passwordVal">Repetir contraseña</label>
                </p-floatLabel>
                @if (formRecovery.controls.passwordVal.hasError('required') && formRecovery.controls.passwordVal.touched && !formRecovery.controls.passwordVal.hasError('passNoCoinciden')) {
                    <small class="p-error block mt-1">Debe repetir la contraseña</small>
                }
                @if (formRecovery.controls.passwordVal.hasError('minlength') && formRecovery.controls.passwordVal.touched && !formRecovery.controls.passwordVal.hasError('passNoCoinciden')) {
                    <small class="p-error block mt-1">Debe tener al menos 6 caracteres</small>
                }
                @if (formRecovery.controls.passwordVal.hasError('passNoCoinciden') && formRecovery.controls.passwordVal.touched) {
                    <small class="p-error block mt-1">Las contraseñas no coinciden</small>
                }
            </div>
            
            <div class="flex flex-column gap-3 mt-2">
                <p-button label="Solicitar código" type="button" (onClick)="recoverPassword()" severity="help" styleClass="w-full p-button-lg" [disabled]="!formRecovery.controls.userName.value || disabledButton || isLoading" [loading]="isLoading"></p-button>
                <p-button label="Restablecer contraseña" type="button" (onClick)="resetPassword()" styleClass="w-full p-button-lg" [disabled]="formRecovery.invalid || isLoading" [loading]="isLoading"></p-button>
                <p-button label="Volver" severity="secondary" (onClick)="toForgot()" [disabled]="isLoading" styleClass="w-full"></p-button>
            </div>
        </form>

        <footer class="mt-auto pt-6">
            <div *ngIf="isClientMode && emailsActive && !forgot" class="contact-section text-center">
                <h3 class="text-xs font-bold text-400 uppercase tracking-widest mb-3">Soporte Técnico</h3>
                <div class="flex flex-column gap-2 align-items-center">                
                    <div *ngFor="let email of emails" (click)="copyTo(email.email)" 
                         class="email-link-item flex align-items-center gap-2 text-sm text-600 cursor-pointer">
                        <i class="pi pi-envelope"></i>
                        <span>{{email.email}}</span>
                    </div>
                </div>
            </div>

            <div class="mt-5 flex justify-content-center">
                <app-powered-by *ngIf="appSettings?.frontend?.general?.showClientLogo"></app-powered-by> 
            </div>
        </footer>
    </div>
</div>







<!-- <div fxLayout="column" fxLayoutAlign='center center' fxFlexFill>

    <mat-card  fxLayout='column' fxLayoutAlign='center center'>
        
        <img *ngIf="!appSettings?.frontend?.general?.showClientLogo" src="../../../assets/img/static/biworklims.svg" alt="Icono Usuario">
        <img *ngIf="appSettings?.frontend?.general?.showClientLogo"id='client-logo' src="../../../assets/img/client/clientLogo.png" alt="Icono Cliente">
        
        
        <form [formGroup]="form" (submit)='userLogin(form.value)' fxLayout='column'>

            <mat-form-field fxFlex='100' appearance='outline'>
                <mat-label>Usuario</mat-label>
                <input matInput type='text' formControlName='user' placeholder="Usuario" autocomplete="off"
                [disabled]='isLoading'>
                <mat-error *ngIf='form.controls.user.invalid'>Ingrese un usuario valido</mat-error>
            </mat-form-field>
            
            <mat-form-field fxFlex='100' appearance='outline'>
                <mat-label>Password</mat-label>
                <input [type]="hide ? 'password' : 'text'" formControlName='password' matInput [disabled]='isLoading'
                placeholder="Password" autocomplete="off">
                <button mat-icon-button matSuffix type='button' (click)="hide = !hide">
                    <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                </button>
                <mat-error *ngIf='form.controls.password.invalid'>Password invalido</mat-error>
            </mat-form-field>
            
            <div fxLayout='row' fxLayoutGap='15px'>
                <button mat-raised-button color='primary' type='submit' [disabled]='form.invalid || isLoading'>
                    <span>Ingresar</span>
                </button>
                <mat-spinner *ngIf='isLoading' diameter="30"></mat-spinner>
            </div>
        </form>
        
    </mat-card>
    
    <app-powered-by *ngIf="appSettings?.frontend?.general?.showClientLogo"></app-powered-by> 
</div> -->

